import { createContext } from "react";

export const buyTokenPopUpContext = createContext();
